import { getReactNavigationRouteName } from "../getReactNavigationConfig";
function _type_of(obj) {
  "@swc/helpers - typeof";
  return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function focusedRouteOf(state) {
  return typeof state.index === "number" ? state.routes[state.index] : state.routes[state.routes.length - 1];
}
function isStateAwaitingNavigatorMount(state, rootNode) {
  var _loop = function() {
    var route = focusedRouteOf(current);
    if (!route) return {
      v: false
    };
    var child = node.children.find(function(candidate) {
      return getReactNavigationRouteName(candidate) === route.name;
    });
    if (!child) return {
      v: false
    };
    if (route.state) {
      node = child;
      current = route.state;
      return "continue";
    }
    return {
      v: child.children.some(function(grandchild) {
        return !grandchild.internal;
      })
    };
  };
  var _current_routes;
  if (!rootNode) return false;
  var node = rootNode;
  var current = state;
  while (current === null || current === void 0 ? void 0 : (_current_routes = current.routes) === null || _current_routes === void 0 ? void 0 : _current_routes.length) {
    var _ret = _loop();
    if (_type_of(_ret) === "object") return _ret.v;
  }
  return false;
}
export {
  isStateAwaitingNavigatorMount
};
//# sourceMappingURL=isStateAwaitingNavigatorMount.js.map
